import React from "react";
import AdminCohortList from "./AdminCohortList";
import HeaderBar from "../../Users/common/HeaderBar";
import SideBar from "../../Users/common/SideBar";

const AdminCohortMainPage = () => {
  return (
    <main className="f22 main-page">
      <HeaderBar />
      <div className="overflow-hidden inner-page-content inner-page-content--aira-chat">
        <SideBar />
        <AdminCohortList />
      </div>
    </main>
  );
};

export default AdminCohortMainPage;

